import React, { useEffect } from 'react';
import ParentComponent from '..';
import metaLogo from "../../../../assets/guardian.png";
import { Helmet } from "react-helmet";

const TokenError = () => {
  const alertMainHeading = 'We can\'t find your information';
  const alertInfoText =
    'Check the link you entered and make sure it\'s correct.';

  const tokenPropsData = {
    alertMainHeading,
    alertInfoText,
  };

  useEffect(() => {
    document.title = 'Token Error | Guardian';
  }, [])

  return (
    <>
      <Helmet>
        <link rel="icon" type="image/png" href={metaLogo} />
      </Helmet>
      <ParentComponent propData={tokenPropsData} />
    </>
  );
};

export default TokenError;